export default __webpack_public_path__ + "static/media/7.660ca3a2.webp";